import { FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";
import ModalNav from "./ModalNav";

interface IModalHeader {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  watch: UseFormWatch<FormTypes>;
  toggleModal: boolean;
  setToggleModal: Function;
  step: number;
  setAnyStep: Function;
  saveAndClose: Function;
  projectName: string | undefined;
}

function ModalHeader(props: IModalHeader) {
  const { toggleModal, setToggleModal, register, errors, step, setAnyStep, saveAndClose, projectName } =
    props;
  return (
    <>
      <div
        className="d-flex"
        style={{
          justifyContent: "start",
          flexDirection: "column",
          width: "25%",
        }}
      >
        {step > 1 ? (
          <button
            type="button"
            className="action primary"
            onClick={() => setAnyStep(step - 1)}
          >
            Back
          </button>
        ) : null}
        <input
          type="text"
          className="mt2 w-100"
          style={{ borderRadius: "5px" }}
          placeholder="Project name here"
          defaultValue=""
          {...register("projectName")}
        />
        {!projectName && (
          <span style={{ color: "white" }}>
            A project name is required to save
          </span>
        )}
      </div>
      <div className="modal-footer d-flex">
        <ModalNav step={step} setAnyStep={setAnyStep} />
      </div>
      <div
        className="d-flex"
        style={{
          justifyContent: "start",
          flexDirection: "column",
          width: "25%",
        }}
      >
        <button
          type="button"
          className="action primary mb1"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => setToggleModal(!toggleModal)}
        >
          Close
        </button>
        <button
          type="button"
          className="action primary"
          data-dismiss="modal"
          aria-label="Save"
          disabled={!projectName ? true : false}
          onClick={() => saveAndClose()}
        >
          Save & Close
        </button>
      </div>
    </>
  );
}

export default ModalHeader;
